package pnemonic.balloon_pop.drawable

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

val Ruby: ImageVector
    get() {
        if (_Ruby != null) {
            return _Ruby!!
        }
        _Ruby = ImageVector.Builder(
            name = "Ruby",
            defaultWidth = 30.122.dp,
            defaultHeight = 46.82.dp,
            viewportWidth = 30.122f,
            viewportHeight = 46.82f
        ).apply {
            path(
                fill = SolidColor(Color(0xFFB5211D)),
                fillAlpha = 0.8f
            ) {
                moveTo(6.522f, 30.36f)
                lineToRelative(0f, -13.9f)
                lineToRelative(8.542f, -6.95f)
                lineToRelative(8.542f, 6.95f)
                lineToRelative(0f, 13.9f)
                lineToRelative(-8.542f, 6.951f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF801814)),
                fillAlpha = 0.8f
            ) {
                moveTo(7.101f, 30.014f)
                lineToRelative(0f, -13.208f)
                lineToRelative(7.963f, -6.604f)
                lineToRelative(7.963f, 6.604f)
                lineToRelative(0f, 13.208f)
                lineToRelative(-7.963f, 6.604f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFDD3B25)),
                fillAlpha = 0.8f
            ) {
                moveTo(7.789f, 29.621f)
                lineToRelative(0f, -12.422f)
                lineToRelative(7.275f, -6.211f)
                lineToRelative(7.275f, 6.211f)
                lineToRelative(0f, 12.422f)
                lineToRelative(-7.275f, 6.212f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF801814)),
                fillAlpha = 0.8f
            ) {
                moveTo(30.122f, 35.115f)
                lineToRelative(-15.058f, 11.705f)
                lineToRelative(0f, -9.51f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFB5211D)),
                fillAlpha = 0.8f
            ) {
                moveTo(30.122f, 35.115f)
                lineToRelative(-15.058f, 2.196f)
                lineToRelative(8.542f, -6.951f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF801814)),
                fillAlpha = 0.8f
            ) {
                moveTo(30.122f, 11.705f)
                lineToRelative(0f, 23.41f)
                lineToRelative(-6.517f, -4.755f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFB5211D)),
                fillAlpha = 0.8f
            ) {
                moveTo(30.122f, 11.705f)
                lineToRelative(-6.517f, 18.655f)
                lineToRelative(0f, -13.9f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF55038)),
                fillAlpha = 0.8f
            ) {
                moveTo(15.064f, 9.509f)
                lineToRelative(8.542f, 6.95f)
                lineToRelative(-8.542f, -16.46f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFDD3B25)),
                fillAlpha = 0.8f
            ) {
                moveTo(23.605f, 16.46f)
                lineToRelative(6.517f, -4.755f)
                lineToRelative(-15.058f, -11.705f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFB5211D)),
                fillAlpha = 0.8f
            ) {
                moveTo(-0f, 35.115f)
                lineToRelative(15.058f, 11.705f)
                lineToRelative(0f, -9.51f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFDD3B25)),
                fillAlpha = 0.8f
            ) {
                moveTo(-0f, 35.115f)
                lineToRelative(15.058f, 2.196f)
                lineToRelative(-8.542f, -6.951f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFB5211D)),
                fillAlpha = 0.8f
            ) {
                moveTo(-0f, 11.705f)
                lineToRelative(0f, 23.41f)
                lineToRelative(6.517f, -4.755f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFDD3B25)),
                fillAlpha = 0.8f
            ) {
                moveTo(-0f, 11.705f)
                lineToRelative(6.517f, 18.655f)
                lineToRelative(0f, -13.9f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFDD3B25)),
                fillAlpha = 0.8f
            ) {
                moveTo(15.058f, 9.509f)
                lineToRelative(-8.542f, 6.95f)
                lineToRelative(8.542f, -16.46f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF55038)),
                fillAlpha = 0.8f
            ) {
                moveTo(6.517f, 16.46f)
                lineToRelative(-6.517f, -4.755f)
                lineToRelative(15.058f, -11.705f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.8f
            ) {
                moveTo(7.395f, 15.587f)
                lineToRelative(4.067f, 0.873f)
                lineToRelative(-4.067f, 0.873f)
                lineToRelative(-0.873f, 4.067f)
                lineToRelative(-0.873f, -4.067f)
                lineToRelative(-4.067f, -0.873f)
                lineToRelative(4.067f, -0.873f)
                lineToRelative(0.873f, -4.067f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.8f
            ) {
                moveTo(23.024f, 29.837f)
                lineToRelative(2.008f, 0.432f)
                lineToRelative(-2.008f, 0.431f)
                lineToRelative(-0.431f, 2.009f)
                lineToRelative(-0.431f, -2.009f)
                lineToRelative(-2.009f, -0.431f)
                lineToRelative(2.009f, -0.432f)
                lineToRelative(0.431f, -2.009f)
                close()
            }
        }.build()

        return _Ruby!!
    }

@Suppress("ObjectPropertyName")
private var _Ruby: ImageVector? = null
